import { Component } from '@angular/core';
import { ApplicationStateService } from '../../../services/application-state.service';
import { AbstractToolsBarComponent } from '../../tools-bar/abstract-tools-bar-component';
import { BookFeatureActivationService } from '../../../services/book-feature-activation.service';
import { FabricService } from '../../../services/fabric.service';
import { ModalService } from '../../../services/modal.service';
import { CommunicationService } from '../../../services/communication.service';
import { AssetPipe } from '../../../pipes/asset.pipe';
import { ToolsBarDropUpComponent } from './tools-bar-drop-up/tools-bar-drop-up.component';

@Component({
    selector: 'app-mobile-tools-bar',
    templateUrl: './mobile-tools-bar.component.html',
    styleUrls: ['./mobile-tools-bar.component.scss'],
    standalone: true,
    imports: [
        AssetPipe,
        ToolsBarDropUpComponent
    ]
})
export class MobileToolsBarComponent extends AbstractToolsBarComponent {

    constructor(
        public applicationStateService: ApplicationStateService,
        public featureActivationService: BookFeatureActivationService,
        protected fabricService: FabricService,
        protected modalService: ModalService,
        protected communicationService: CommunicationService) {
        super();
    }
}
